import { FC } from 'react';

import DOMPurify from 'dompurify';
import { cn } from 'utils/helpers';

export type SimpleEmailEntryProps = {
  isLoading: boolean;
  date: string;
  subject: string;
  isUnread: boolean;
  onClick?: () => void;
  snippet: string;
};

const SimpleEmailEntry: FC<SimpleEmailEntryProps> = ({
  date,
  subject,
  isUnread,
  onClick,
  snippet,
  isLoading,
}) => {
  if (isLoading) {
    return (
      <div className="rounded-[6px] animate-pulse h-[94px] w-full p-[22px] bg-fill-tertiary">
        <div className="w-full h-[16px] bg-[#F7FAFF] mb-[6px]" />
        <div className="w-1/4 h-[8px] bg-[#F7FAFF]" />
        <div className="w-full h-[16px] mt-[6px] bg-[#F7FAFF]" />
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'text-secondary p-[22px]',
        'text-left w-full',
        'rounded-[6px]',
        isUnread ? 'bg-fill-secondary' : 'bg-fill-tertiary',
      )}
    >
      <div className="font-semibold leading-6 tracking-wider">{subject}</div>
      <div className="text-xs leading-5 tracking-wider">{date}</div>
      <div
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(snippet),
        }}
        className="mt-[6px] line-clamp-2 "
      />
    </button>
  );
};

export default SimpleEmailEntry;
